import { gql } from "@apollo/client";
// query($operatorId: ID!, $partnerId: ID){
//   partners(operatorId:$operatorId, partnerId:$partnerId){
//     	partnerId
//     	companyNickname
//     	partnerLockerTypes{
//         lockerType{
//           lockerType
//           description
//         }
//         partner{
//           partnerType{
//             partnerType
//             partnerCategory{
//               partnerCategory
//             }
//             monthlyFee
//         	}
//           loadBalance
//         }

//       }
//   }
// }
export const SEARCH_PARTNERS = gql`
  query ($operatorId: ID!, $partnerId: ID) {
    searchCouriers(operatorId: $operatorId, partnerId: $partnerId) {
      partnerId
      operator {
        operatorId
        company
      }
      companyNickname
      tinNumber
      loadBalance
      partnerStatus
      featuresCod
      featuresShipout
      featuresReturns
      address
      zipCode
      contactPerson
      contactPerson2
      contactPosition
      contactPosition2
      mobile
      mobile2
      landline
      landline2
      email
      email2
      paymentSchedule {
        paymentScheduleNo
        paymentSchedule
      }
      partnerAgentIdTypes {
        idType {
          idTypeId
          idType
        }
      }
      remarks
      partnerLogoUrl
      partnerType {
        partnerTypeId
        partnerType
        monthlyFee
        partnerCategory {
          partnerCategoryNo
          partnerCategory
        }
        partnerLockerTypeAccess {
          lockerType {
            lockerType
            lockerTypeId
          }
        }
      }
      partnerAccounts {
        username
        partnerAccountId
        username
        active
        userMobile
        userEmail
        accessPermissions
        adminAccess
      }
      agentTopupAmount
      agentTopupSourceNo
      agentTopupThreshold
      # agentSourceFundNo intentionally omitted: agent_fund_source_no column
      # does not exist on the live database yet.
      # agentSourceFundNo
      walletBalance
    }
  }
`;
export const SEARCH_PARTNERS_FOR_TABLE = gql`
  query (
    $operatorId: ID!
    $partnerTypeId: ID
    $partnerCategoryId: ID
    $partnerId: ID
    $selectedFeatures: [String]
    $isSuperadmin: Boolean
  ) {
    searchCouriers(
      operatorId: $operatorId
      partnerTypeId: $partnerTypeId
      partnerCategoryId: $partnerCategoryId
      partnerId: $partnerId
      selectedFeatures: $selectedFeatures
      isSuperadmin: $isSuperadmin
    ) {
      partnerId
      partnerCategory {
        partnerCategory
        partnerCategoryNo
      }
      companyNickname
      partnerStatus
      featuresCod
      featuresShipout
      featuresReturns
      partnerType {
        monthlyFee
        partnerCategory {
          partnerCategoryNo
        }
      }
      loadBalance
      partnerAccounts {
        partnerAccountId
        adminAccess
      }
      operator {
        operatorId
        company
      }
      agentTopupAmount
      agentTopupSourceNo
      agentTopupThreshold
      walletBalance
    }
  }
`;

export const PARTNER_CATEGORY = gql`
  {
    partnerCategories {
      partnerCategory
      partnerCategoryNo
    }
  }
`;
export const ID_TYPES = gql`
  {
    idTypes {
      idType
      idTypeId
    }
  }
`;

export const PAYMENT_MODES = gql`
  {
    paymentSchedules {
      paymentSchedule
      paymentScheduleNo
    }
  }
`;

export const UPDATE_PARTNER_PROFILE = gql`
  mutation ($couriers: [UpdateCourierProfileObject]!) {
    updateCourier(couriers: $couriers) {
      courierProfile {
        partnerId
      }
    }
  }
`;
export const CREATE_PARTNER = gql`
  mutation ($couriers: [CreateCourierProfileObject]) {
    createCourier(couriers: $couriers) {
      courierProfile {
        partnerId
      }
    }
  }
`;

export const PARTNER_TYPE_FOR_PARTNER = gql`
  query ($operatorId: ID!, $partnerCategoryNo: Int) {
    partnerTypes(
      operatorId: $operatorId
      partnerCategoryNo: $partnerCategoryNo
    ) {
      partnerTypeId
      partnerType
      lockerPartnerLimits {
        pickupPulloutLimit
      }
    }
  }
`;
export const LOCKER_TYPES_FOR_PARTNER = gql`
  {
    lockerTypes {
      lockerTypeId
      lockerType
    }
  }
`;
export const PARTNER_CATEGORY_FOR_PARTNER = gql`
  {
    partnerCategories {
      partnerCategoryNo
      partnerCategory
    }
  }
`;

export const FIND_AGENT_TOPUP_SOURCE = gql`
  {
    allPartnerAgentTopupSource {
      value
      label
    }
  }
`;
